export class AuthState {
  constructor() {
    this.userLogin = '';
    this.userForgotPassword = '';
    this.userResetPassword = '';
  }
}
